import { useEffect, useRef, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Messages } from 'primereact/messages';
import { useNavigate } from 'react-router-dom';
import { classNames } from 'primereact/utils';
import './login.css';
import { Fetch } from '../../shared/Fetch';
import { ILogin } from '../../models/Login';

interface IFormInputs {
    email: string
    password: string
}

const schema = yup.object({
    email: yup.string().email().required("email is required*"),
    password: yup.string().required("password is required*"),
});


export const Login = () => {
    const message = useRef<any>(null);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const { control, handleSubmit, formState: { errors }, setFocus } = useForm<IFormInputs>({
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        if (!loading) {
            const form = document.querySelector('form');
            form?.classList.add('invalid_details');
            setTimeout(() => {
                form?.classList.remove('invalid_details');
            }, 550);
        }
    }, [loading]);

    useEffect(() => {
        setFocus("email");
    }, [setFocus]);

    // async function onSubmitLogin(data: IFormInputs) {
    //     setLoading(true);
    //     const response = await Fetch("login", "POST", data, null, message);
    //     if (response) {
    //         const data: ILogin = await response.json();
    //         console.log(data);
    //         sessionStorage.setItem('auth', JSON.stringify(data));
    //         navigate('/');
    //     }
    //     else {
    //         setLoading(false);
    //     }
    // }

    async function onSubmitLogin(formData: IFormInputs) {
        try {
            setLoading(true);
            const response = await Fetch("login", "POST", formData, null, message);
            if (!response || !response.ok) {
                setLoading(false);
                return;
            }          
            const loginData: ILogin = await response.json();
            sessionStorage.setItem("auth", JSON.stringify(loginData));
            if (loginData.kommunoExists) {
                const response1 = await Fetch("Kommuno/sso-login", "GET", null, null, null);
                if (response1 && response1.ok) {
                    const ssoData = await response1.json();
                    if (ssoData.urls) {
                        window.open(ssoData.urls, "_blank");
                    }
                }
            }
            navigate("/");
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }


    return (
        <div className="login-container">
            <img src="img/logo.svg" width={256} alt="Jungleavengers" />
            <form onSubmit={handleSubmit(onSubmitLogin)} className="login-box">
                <div className="card">
                    <h5 className='text-center'>Login</h5>
                    <Messages ref={message} />
                    <div className="grid p-fluid">
                        <div className="col-12 md:col-12">
                            <div className="p-inputgroup">
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-user"></i>
                                </span>
                                <Controller name='email' control={control} defaultValue={''} render={({ field, fieldState }) => (
                                    <InputText {...field} className={classNames({ 'p-invalid': fieldState.invalid })} placeholder="Email" />
                                )} />
                            </div>
                        </div>
                        <small className="p-error" style={{ marginLeft: "3.5rem", marginTop: "-1rem" }}>{errors.email?.message}</small>
                        <div className="col-12 md:col-12">
                            <div className="p-inputgroup">
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-lock"></i>
                                </span>
                                <Controller name='password' control={control} defaultValue={''} render={({ field, fieldState }) => (
                                    <InputText {...field} className={classNames({ 'p-invalid': fieldState.invalid })} type="password" placeholder="Password" />
                                )} />
                            </div>
                        </div>
                        <small className="p-error" style={{ marginLeft: "3.5rem", marginTop: "-1rem" }}>{errors.password?.message}</small>
                        <div className="col-12 md:col-12">
                            <Button label="LOGIN" type="submit" loading={loading} className='p-button-rounded'></Button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};
